import { getFilteredPages, getSortedPages } from '../lib';
import { useFilterPages } from './use-show-page';
import { useSort } from './use-sort';

import { useMemo } from 'react';
import { Page } from '@distribute/shared/types';

type Params = {
  pages: Page[];
};

export const useFilteredPages = ({ pages }: Params) => {
  const { sort } = useSort();
  const { filter } = useFilterPages();

  return useMemo(() => {
    let _pages = getFilteredPages(pages, filter);
    _pages = getSortedPages(_pages, sort);

    return _pages;
  }, [filter, sort, pages]);
};
